import { EmailSyncIcon } from './EmailSyncIcon';

/**
 * author: Simran
 * id 72B2D41E-42AA-44E7-8F1E-42AC62577F73
 * name email-sync
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-sync.svg
 * tags
 */
export const EmailResendIcon = EmailSyncIcon;
export default EmailResendIcon